module.exports = __webpack_public_path__ + "static/media/Ken-Oda.84b07256.png";